import { defineMessages } from 'react-intl';

export default defineMessages({
     removeInfo: {
        id: 'quoteandbind.PPRLinedirectives.templates.Remove Risk Assist - Dwellings',
        defaultMessage: 'Remove Risk Assist - Dwellings Details',
    },
    removeInfoDesc: {
        id: 'quoteandbind.PPRLinedirectives.templates.Risk Assist - Dwellings',
        defaultMessage: 'Are you sure you want to remove this Risk Assist - Dwellings Details from the list?',
    },
});